module.exports = {
  familyName: 'Noto Sans',
  category: 'sans-serif',
  capHeight: 714,
  ascent: 1069,
  descent: -293,
  lineGap: 0,
  unitsPerEm: 1000,
  xHeight: 536,
  xWidthAvg: 471
};
